import { Content } from "@/components/Content";
import { createTitle } from "@/functions/createTitle";
import * as additionalComponents from "./__components";
import { getCaseStudies } from "@/getters/getCaseStudies";

export default function Page({ content }) {
  return (
    <>
      <Content items={content} additionalComponents={additionalComponents} />
    </>
  );
}

export async function getStaticProps({ params: { url_slug } }) {
  const item = getCaseStudies({ url_slug });

  if (!item) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      meta: {
        title: createTitle(item.title, "Case Studies"),
      },
      content: [
        { component: "Banner", props: { className: "", ...item } },
        { component: "Intro", props: { className: "", ...item } },
        { component: "Requirement", props: { className: "", ...item } },
        { component: "Progress", props: { className: "", ...item } },
        { component: "Delivery", props: { className: "", ...item } },
        { component: "Results", props: { className: "", ...item } },
      ],
    },
  };
}

export async function getStaticPaths() {
  const allCaseStudies = getCaseStudies();

  const paths = allCaseStudies.map((item) => ({
    params: {
      url_slug: item.url_slug,
    },
  }));

  return {
    paths,
    fallback: false,
  };
}
